// extracted by mini-css-extract-plugin
module.exports = {"IngredientDetailPage":"IngredientDetail_IngredientDetailPage__28IT8","title":"IngredientDetail_title__1rdd7"};